import 'css-chunksrc/client/scenes/projectExpenseCreation/form/styles.scss';export default {
  "form": "_form_pvv9a_1",
  "group": "_group_pvv9a_5",
  "row": "_row_pvv9a_9",
  "wideCell": "_wideCell_pvv9a_16",
  "label": "_label_pvv9a_23",
  "root": "_root_pvv9a_29",
  "list": "_list_pvv9a_33",
  "attachments": "_attachments_pvv9a_40"
};